// Bundler-injected env (Next.js, Vite, Webpack DefinePlugin) — declared
// locally so we don't need a hard @types/node devDependency.
declare const process: { env: Record<string, string | undefined> };

export function detectLocale(): string {
  if (typeof navigator === "undefined") return "US";
  const lang = navigator.language || "";
  const region = lang.split("-")[1]?.toUpperCase();
  if (region === "GB") return "UK";
  if (region) return region;
  const map: Record<string, string> = {
    en: "US", ja: "JP", ko: "KR", zh: "CN", fr: "FR",
    it: "IT", de: "DE", es: "ES", pt: "BR",
  };
  return map[lang.split("-")[0].toLowerCase()] || "US";
}

/**
 * Read `process.env.NEXT_PUBLIC_PRIMESTYLE_API_KEY` when a host still uses
 * the legacy browser-key flow. First-party/proxy integrations can leave it
 * empty; request helpers will simply omit the Authorization header.
 *
 * IMPORTANT: this MUST be a literal `process.env.X` access, NOT a
 * dynamic property read like `process.env[key]`. Bundlers (Next.js
 * SWC, Vite `define`, Webpack DefinePlugin) only perform STATIC
 * replacement of literal property accesses. A dynamic access escapes
 * the replacement and falls through to a runtime `process` lookup,
 * which throws `ReferenceError: process is not defined` in any
 * pure-browser context (Shopify storefront, etc.).
 *
 * The try/catch is the runtime safety net for environments that
 * neither replace at build time NOR provide a `process` shim.
 */
export function getApiKey(): string {
  let key = "";
  try {
    key = process.env.NEXT_PUBLIC_PRIMESTYLE_API_KEY ?? "";
  } catch {
    /* no process global — leave key empty */
  }
  return key;
}

export function getApiUrl(override?: string): string {
  if (override) return override;
  let envUrl = "";
  try {
    envUrl = process.env.NEXT_PUBLIC_PRIMESTYLE_API_URL ?? "";
  } catch {
    /* no process global */
  }
  return envUrl || "http://localhost:4000";
}
